require('../../modules/es6.object.create');
var $Object = require('../../modules/_core').Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/library/fn/object/create.js
// module id = ../node_modules/core-js/library/fn/object/create.js
// module chunks = 0